import { render, staticRenderFns } from "./ParcelCard.vue?vue&type=template&id=a140c930&scoped=true&"
import script from "./ParcelCard.vue?vue&type=script&lang=ts&"
export * from "./ParcelCard.vue?vue&type=script&lang=ts&"
import style0 from "./ParcelCard.vue?vue&type=style&index=0&id=a140c930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a140c930",
  null
  
)

export default component.exports